module.exports = __webpack_public_path__ + "img/smallArrow.5cb5b138.svg";